// src/components/admin/TreasuryBalanceWidget.jsx
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Wallet, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getTreasuryBalances } from "@app/features/admin/walletApi";

function format(n, d = 2) {
  const num = Number(n || 0);
  if (!Number.isFinite(num)) {
    return (0).toLocaleString(undefined, {
      maximumFractionDigits: d,
      minimumFractionDigits: d,
    });
  }
  return num.toLocaleString(undefined, {
    maximumFractionDigits: d,
    minimumFractionDigits: d,
  });
}

export function TreasuryBalanceWidget() {
  const {
    data: treasuryData,
    isLoading,
    refetch
  } = useQuery({
    queryKey: ['adminTreasuryBalanceWidget'],
    queryFn: getTreasuryBalances,
    staleTime: 60000 // 1 minute
  });
  
  return (
    <div className="bg-gray-900 rounded-xl border border-gray-800 p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-indigo-600 to-purple-600 grid place-items-center text-white">
            <Wallet size={20} />
          </div>
          <h3 className="text-lg font-semibold text-white">Treasury Balances</h3>
        </div>
        <button 
          onClick={() => refetch()} 
          className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-400 hover:text-white"
          disabled={isLoading}
        >
          <RefreshCw size={16} className={isLoading ? 'animate-spin' : ''} />
        </button>
      </div>
      
      {isLoading ? (
        <div className="py-6 flex justify-center text-gray-500">
          <RefreshCw size={24} className="animate-spin" />
        </div>
      ) : treasuryData?.balances ? (
        <>
          <div className="space-y-2 mt-2">
            {treasuryData.balances.map((balance, i) => (
              <div key={i} className="flex items-center justify-between">
                <span className="text-gray-400">
                  {balance.asset} ({balance.network}):
                </span>
                <span className="text-white font-medium font-mono">
                  {format(balance.balance, balance.asset === 'BTC' ? 8 : balance.asset === 'ETH' ? 6 : 2)}
                </span>
              </div>
            ))}
          </div>
          
          <div className="mt-3 pt-3 border-t border-gray-800 flex items-center justify-between">
            <span className="text-gray-400">Total USD Value:</span>
            <span className="text-green-400 font-bold">
              ${treasuryData.totalUsdValue ? format(treasuryData.totalUsdValue, 2) : '—'}
            </span>
          </div>
        </>
      ) : (
        <div className="py-6 text-center text-gray-500">
          No treasury data available
        </div>
      )}
      
      <Link 
        to="/admin/treasury" 
        className="mt-4 block w-full py-2 text-center rounded-lg bg-indigo-700 hover:bg-indigo-600 text-white text-sm"
      >
        Manage Treasury
      </Link>
    </div>
  );
}
